import { CORE_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';

export const useIsBusinessProject = () => {
	const { data, loading } = useProjectContext();
	const isBusinessProject = data?.projectType === CORE_PROJECT;

	return { isBusinessProject, loading };
};
